import TemplateLayout from "../../../../../providers/TemplateLayout";

function CustomEndorsement({
  templateName,
}: {
  templateName: string;
}): JSX.Element {
  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR</label>
      </div>
      <div className="col-12 my-2">
        <textarea className="form-control"></textarea>
      </div>
    </TemplateLayout>
  );
}

export default CustomEndorsement;
